import React from "react";
import "./ButtonCancel.css";
import { useTranslation } from "react-i18next";

export default function ButtonCancel({
  onClick,
  ariaLabel,
  disabled = false,
  className = "",
  children,
  type = "button",
  style,
}) {
  const { t } = useTranslation('common');
  const computedLabel = children ?? t('buttons.cancel');
  const computedAria = ariaLabel ?? computedLabel;
  return (
    <button
      type={type}
      onClick={onClick}
      aria-label={computedAria}
      disabled={disabled}
      className={(
        `user-modal-btn user-modal-btn-secondary ` +
        `user-level-modal-btn user-level-modal-btn-secondary ` +
        className
      ).trim()}
      style={style}
    >
      {computedLabel}
    </button>
  );
}
